module.exports = __webpack_public_path__ + "img/list_1.0ae720da.jpg";